import { formatDate } from 'lib/helpers/utility';

const DEFAULT_FILTERS = {
  id: {
    type: 'search',
    values: null,
    title: 'ID',
    placeholder: 'Search by ID',
    preview: (values) => values
  },
  dob: {
    values: null,
    type: 'date-range',
    title: 'Date of Birth',
    preview: (values) => `${formatDate(values.startDate)} - ${formatDate(values.endDate)}`
  },
  f_name: {
    type: 'search',
    values: null,
    title: 'First Name',
    placeholder: 'Search by First Name',
    preview: (values) => values
  },
  l_name: {
    type: 'search',
    values: null,
    title: 'Last Name',
    placeholder: 'Search by Last Name',
    preview: (values) => values
  },
  email: {
    type: 'search',
    values: null,
    title: 'Email',
    placeholder: 'Search by Email',
    preview: (values) => values
  },
  phone: {
    type: 'search',
    values: null,
    title: 'Phone',
    placeholder: 'Search by Phone',
    preview: (values) => values
  },
  status: {
    type: 'search',
    multiple: true,
    title: 'Status',
    options: [
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' }
    ]
  }
};

export default DEFAULT_FILTERS;
